import { createSelector } from 'reselect'

export const getStationDetailsData = createSelector(
  state => state?.scheduleTechnicalInspection?.stationDetailsData ?? null,
  stationDetailsData => stationDetailsData
)
